<p-toast></p-toast>
<div class="mw-100" style="background-color: white; height: 100%;">
    <app-navbar></app-navbar>
    <div class="container">
      <form autocomplete="off" class="form-horizontal" enctype="multipart/form-data" (ngSubmit)="enviarMensaje()">
        <div class="p-card p-component">
          <div class="button" style="margin-left: 15px;">
            <button class="p-button p-component btn" (click)="regresar(deviceUrl, deviceName)">Menu</button>
        </div>
        <app-device-status-message [deviceUrl]="deviceUrl"></app-device-status-message>
          <div class="p-card-header p-component p-card-header-primary">
            <h5 class="pdfs-15">{{ 'MESSAGE_MULTIPLE_CONTACTS' | translate}}</h5>
          </div>
          <div class="p-card-body p-component">
            <!--Mensaje -->
            <div class="p-grid">
              <div class="p-col-3">
                <label class="customfont1">{{ 'PHONE' | translate}}</label>
              </div>
            </div>
           <!-- Opción de ingreso manual -->
            <div class="p-grid">
              <div class="p-col-3">
                <div class="p-field-checkbox">
                  <div class="p-field-checkbox">
                    <input type="radio" name="opcionLista" value="1" id="opc1" class="p-radiobutton-input" [checked]="ingresoManualSeleccionado" (change)="cambiarOpcion('1', $event)" inputId="opc1">
                    <label class="customfont1" for="opc1">{{ 'MANUAL_ENTRY' | translate}}</label>
                  </div>
                </div>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">
                  <textarea class="p-inputtext p-component inputfiled" name="txt-telefonos" id="txt-telefonos" rows="10" required [(ngModel)]="camposMensaje.numerosTexto" resize="none"
                  placeholder="{{ 'NUMBERS' | translate}}:&#10;5215555555555&#10;5215555555555&#10;5215555555555" [disabled]="!ingresoManualSeleccionado"></textarea>
                  <!--Validación campo-->
                  <div *ngIf="camposMensaje.numerosTexto && !verificarSoloNumeros(camposMensaje.numerosTexto)" class="alerta">
                    <div class="alerta">
                      <span>{{ 'ONLY_NUMBERS' | translate}}</span>
                    </div>
                  </div>
                <!--Validación campo--> 
                </div>                
              </div>
            </div>
             <!-- Opción de ingreso por CSV -->
            <div class="p-grid">
              <div class="p-col-3">
                <div class="p-formgroup-inline">
                  <div class="p-field-checkbox">         
                    <div class="p-field-checkbox">
                      <input type="radio" name="opcionLista" value="2" id="opc2" class="p-radiobutton-input" [checked]="importacionCsvSeleccionada" (change)="cambiarOpcion('2', $event)" inputId="opc2">
                      <label class="customfont1" for="opc2">{{ 'CSV_IMPORT' | translate}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">
                    <input class="p-inputtext p-component inputfiled" name="txt-archivoTelefonos" id="txt-archivoTelefonos" type="file" aria-required="true" (change)="onFileSelected($event)"
                    [disabled]="!importacionCsvSeleccionada"/>
                    <a class="descargarCSV" href="../../../../assets/ejemplo1/ejemplo.csv" download>{{ 'EXAMPLE_SELECTED_FILE' | translate}}</a>
                </div>
              </div>
            </div>
            <!-- Opción por tipo de lista -->
          <div class="p-grid">
            <div class="p-col-3">
              <div class="p-formgroup-inline">
                <div class="p-field-checkbox">
                  <div class="p-field-checkbox">
                    <input type="radio" name="opcionLista" value="3" id="opc3" class="p-radiobutton-input" [checked]="listaSeleccionada" (change)="cambiarOpcion('3', $event)" inputId="opc3">
                    <label class="customfont1" for="opc3">{{ 'EXISTING_LIST' | translate}}</label>
                    </div>
                </div>
              </div>
            </div>
            <div class="p-col-7">
              <div class="p-field p-fluid">              
                <select id="txt-tipoLista" name="txt-tipoLista" class="p-dropdown my-select" (change)="seleccionarLista($event)"
                [disabled]="!listaSeleccionada">
                    <option value="0" selected disabled hidden>{{ 'SELECT_LIST' | translate}}</option>
                    <option class="inputfiled" *ngFor="let lista of listas" [value]="lista.id">{{ lista.nombre }}</option>                    
                </select>
            </div>
            </div>
          </div>
            <!-- Nombre de la campaña -->
            <div class="p-grid">
              <div class="p-col-3">
                <label class="customfont1">{{ 'CAMPAIGN_NAME' | translate}}</label>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">
                  <input class="p-inputtext p-component inputfiled" name="txt-nombreCapaña" id="txt-campaña" type="text" 
                  placeholder="{{ 'NAME_CAMPAIGN' | translate}}" aria-required="true" required [(ngModel)]="camposMensaje.nombreCampania" />   
                  <!--Validación campo-->
                    <div *ngIf="validar && !camposMensaje.nombreCampania">
                      <div class="alerta">
                        <span>{{ 'REQUIRED_FILE' | translate}}</span>
                      </div>
                    </div>
                  <!--Validación campo-->
                </div>
              </div>
            </div>
            <!--Mensaje -->
            <div class="p-grid">
              <div class="p-col-3">
                <label class="customfont1">{{ 'MESSAGE_TITLE' | translate}}</label>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">
                  <input class="p-inputtext p-component inputfiled" name="txt-mensaje" id="txt-mensaje" type="text" 
                  placeholder="{{ 'MESSAGE' | translate}}" aria-required="true" required [(ngModel)]="camposMensaje.mensaje"/>     
                  <!--Validación campo-->
                  <div *ngIf="validar && !camposMensaje.mensaje">
                    <div class="alerta">
                      <span>{{ 'REQUIRED_FILE' | translate}}</span>
                    </div>
                  </div>
                <!--Validación campo-->           
                </div>
              </div>
            </div>
            <!--Mensaje -->
            <div class="p-grid">
              <div class="p-col-3">
                <label class="customfont1">{{ 'WEBHOOK' | translate}}</label>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">
                  <input class="p-inputtext p-component inputfiled" name="txt-webhook" id="txt-webhook" type="text" 
                  placeholder="https://webhook.site/" aria-required="true" required/>                
                </div>
              </div>
            </div>
  
          </div>
          <div class="p-card-footer ml-auto mr-auto boton">
            <button type="submit" class="p-button p-component btn">{{ 'SEND' | translate}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>